import posthog from "posthog-js";

import { env } from "./env";

import type { MonitoringProviderClientStrategy } from "../types";

const postHogKey = env.NEXT_PUBLIC_POSTHOG_KEY;

export const strategy = {
  captureException: (exception) => {
    if (!postHogKey) {
      return;
    }

    posthog.captureException(exception);
  },
  identify: <T extends { id: string }>(user: T | null) => {
    if (!postHogKey) {
      return;
    }

    if (user) {
      posthog.identify(user.id);
    } else {
      posthog.reset();
    }
  },
  initialize: () => {
    if (!postHogKey) {
      return;
    }

    posthog.init(postHogKey, {
      api_host: env.NEXT_PUBLIC_POSTHOG_HOST,
    });
  },
  onRouterTransitionStart: () => {
    /* PostHog does not provide a way to capture router transitions yet */
  },
} satisfies MonitoringProviderClientStrategy;
